import { PutYamadumiAutoPriorityReq } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 自動山積優先区分変更API
 */
export class YamadumiAutoPriorityGateway {
  static putYamadumiAutoPriority = async (
    params: PutYamadumiAutoPriorityReq
  ) => {
    return await yamadumiApi.put(
      '/api/simulation/yamadumi-auto-priority', { ...params }, { disableCommonErrorHandling: true }
    )
  }
}
